import axios from 'axios';
import { getAcceptLanguage } from '@/lib/utils';
import { responseErrorHandler, responseHandler } from './response-interceptor';

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'x-origin-key': 'admin',
  },
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  config.headers.set('Accept-Language', getAcceptLanguage());

  return config;
});

api.interceptors.response.use(responseHandler, responseErrorHandler);
